const err = new Error("store-file not implemented");
// eslint-disable-next-line no-console
console.error(err.stack);
throw err;
